import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import SmartCreateFeedbackBannerQuery from './__generated__/SmartCreateFeedbackBannerQuery.graphql';

export function preloadSmartCreateFeedbackBanner(contentId: string) {
	return query({
		query: SmartCreateFeedbackBannerQuery,
		variables: {
			contentId,
		},
	});
}
